import { FC, useContext } from 'react';

import InlineMessage from '@ingka/inline-message';
import infoMessageIcon from '@ingka/ssr-icon/paths/information-circle';
import { t } from '@onlinepayments/payments-library';
import { Redirect } from 'react-router-dom';

import { Card, Loader } from '../../components/toolkit';
import { Path } from '../../enums/Path';
import { PayorderContext } from '../../PayorderContext';

const ValidateOrderContainer: FC = () => {
  const {
    contextState: {
      payorderContext: { contextId: payorderContextId, error: payorderContextError },
      paymentContext: { contextId: paymentContextId },
      queryParams,
    },
  } = useContext(PayorderContext);
  const redirectedFromPsp = !!queryParams.resourcePath || !!queryParams.processing;
  const { orderNumber } = queryParams;

  if (paymentContextId) {
    if (redirectedFromPsp) {
      return <Redirect to={Path.ProcessingPayment} />;
    }

    return <Redirect to={Path.ReviewAndPay} />;
  }

  if (payorderContextId) {
    return <Redirect to={Path.ReviewAndPay} />;
  }

  if (payorderContextError) {
    return (
      <Redirect
        to={{
          pathname: Path.ValidateOrderFailure,
          state: { validationError: payorderContextError, orderNumber },
        }}
      />
    );
  }

  return (
    <Card className="ValidateOrderContainer">
      <Loader />
      <InlineMessage
        role="alert"
        className="mt-200"
        variant="informative"
        ssrIcon={infoMessageIcon}
        title={t('order.validating_order_title')}
        body={t('order.validating_order_message')}
      />
    </Card>
  );
};

export default ValidateOrderContainer;
